import { useState } from 'react'
import CustomSwitch from '../../common/form/CustomSwitch'
import { monthNames } from 'utils/dateFormat';
import { saveAllowanceEdits } from 'store/entities/payroll/payrollSetup/action';
import { toast } from 'react-toastify';
import usePayrollEssentials from 'hooks/usePayrollEssentials';
import { useEffect } from 'react';
import Maybe from 'components/__new/common/Maybe';

const EditAllowanceForm = ({isViewing, submitRef, data}) => {
const {dispatch, lettersRegex, removeNullProperties} = usePayrollEssentials()
const [form, setForm] = useState({is_shown_on_payslip: true});
// const { getPayScheduleData: schedules} = useSelector((state) => state.entities.payrollSetup)

// const monthlyItem = schedules?.data?.find(item => item?.frequency?.payroll_frequency === 'MONTHLY')
// const weeklyItem = schedules?.data?.find(item => item?.frequency?.payroll_frequency === 'WEEKLY')

// const [companyTaxed, setCompanyTaxed] = useState(true);
// const [empTaxed, setEmpTaxed] = useState(false);

const isPercentRate = form?.rate_type?.toLowerCase() === 'percentage'
const deductPercent = form?.rate_type?.toLowerCase() === 'percentage'
const isAnnual = form?.frequency === 'ANNUALLY'

    const allowanceTypes = [
        {title: "Bonus", value: "BONUS"},
        {title: "Backpay", value: "BACKPAY"},
        {title: "Cooperative", value: "COOPERATIVE"},
        {title: "Reimbursement", value: "REIMBURSEMENT"}
    ]

const onSubmit = (e) => {
    e.preventDefault()
    const value = form.value

    if((deductPercent && value > 100 ) || (deductPercent && value < 1)) {
        toast.error('Rate must be between 1 - 100')
    } else if(!deductPercent && value < 1) {
        toast.error('Rate must be at least ₦1')
    } else if(!lettersRegex.test(form?.name)) {
        toast.error('Allowance name must contain letters')
    } else if(form?.frequency === "ANNUALLY" && !form?.month) {
        toast.error("Please select a month under frequency")
    } else {
        const payload = {
            id: data.id,
            ...form,
            month: isAnnual ? Number(form.month) : null,
            value: Number(form.value),
            tax_payer: form?.is_taxable ? "EMPLOYEE" : null,
        }
        dispatch(saveAllowanceEdits(removeNullProperties(payload)))
    }
}

// const toggleRadios = () => {
//     setCompanyTaxed(!companyTaxed)
//     setEmpTaxed(!empTaxed)
// }

const handleChange = (e) => {
    const name = e.target.name
    const value = e.target.value

    setForm({...form, [name]: value})
}


useEffect(() => {
    if(data?.name?.length) {
        setForm(data)
    }
// eslint-disable-next-line
}, [])

    return (
                <form onSubmit={onSubmit}>
                    <div className="p-7">
                        <div className="mb-5">
                            <p className="text-sm mb-2">Name of Allowance</p>
                            <input minLength={3} maxLength={50} disabled={isViewing} type="text" placeholder='Enter name' value={form?.name || ""} onChange={handleChange} name='name' className="form-input" />
                        </div>

                        <div className="mb-5">
                            <p className="text-sm mb-1">Allowance type</p>
                            <select disabled={isViewing} name="type" value={form?.type || ""} onChange={handleChange} className="form-input">
                                <option value="">Select type</option>
                                {allowanceTypes.map(item => <option value={item.value} key={item.value}>
                                    {item.title}
                                </option>)}
                            </select>
                        </div>

                        <div className="mb-5">
                            <p className="text-sm mb-1">Description</p>
                            <textarea disabled={isViewing} style={{resize: "none"}} value={form?.description || ""} rows="3" className="form-input-textarea" placeholder='Enter description' name='description' onChange={handleChange} />
                        </div>
                        <hr />

                        <div className="mb-5 pt-3">
                            <p className="text-sm mb-2">Rate</p>
                            <div className="flex-btw items-center">
                                <div className="w-2/5 mr-3">
                                    <select disabled={isViewing} name="rate_type" value={form?.rate_type} onChange={handleChange} className="form-input">
                                        <option value="">Select rate</option>
                                        <option value="PERCENTAGE">Percentage</option>
                                        <option value="FIXED_AMOUNT">Fixed Amount (₦)</option>
                                    </select>
                                </div>
                                <div className="w-3/5">
                                    <input disabled={isViewing} type="number" placeholder='Enter Value' name='value' value={form?.value || ""}
                                    onChange={handleChange} className="form-input" id="prl-input" />
                                </div>
                            </div>
                            {(isPercentRate && !isViewing) && <p style={{fontSize: '9px'}} className="mb-1 mt-1 text-ep-primary-600">* Percentage of Gross</p>}
                        </div>

                        <div className="mb-5">
                            <p className="text-sm mb-1">Rate source</p>
                            <select disabled={isViewing} value={form?.source || ""} name="source" onChange={handleChange} className="form-input">
                                <option value="">Select source</option>
                                <option value="BASIC">Basic</option>
                                <option value="HOUSING">Housing</option>
                                <option value="TRANSPORT">Transport</option>
                                <option value="BASIC_AND_HOUSING">Basic and Housing</option>
                                <option value="BASIC_AND_TRANSPORT">Basic and Transport</option>
                                <option value="HOUSING_AND_TRANSPORT">Housing and Transport</option>
                                <option value="BASIC_HOUSING_AND_TRANSPORT">Basic, Housing, and Transport</option>
                                <option value="GROSS_SALARY">Gross Salary</option>
                            </select>
                        </div>

                        <hr />

                        <div className="mb-5 pt-3">
                            <p className="text-sm mb-2">Frequency</p>
                            <div className="flex-btw items-center">
                                <div className="w-2/4 mr-3">
                                    <select disabled={isViewing} name="frequency" onChange={handleChange} value={form?.frequency || ""} className="form-input">
                                        <option value="">Select Frequency</option>
                                        <option value="ANNUALLY">Annually</option>
                                        <option disabled value="MONTHLY">Monthly</option>
                                        <option disabled value="WEEKLY">Weekly</option>
                                    </select>
                                </div>
                                <div className="w-2/4">
                                    <select disabled={isViewing} name="month" value={form?.month || ""} onChange={handleChange} className="form-input">
                                        <option value="">Select month</option>
                                        {monthNames.map((item,idx) => <option value={idx + 1} key={item}>{item}</option>)}
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div className="mb-5 border flex-btw p-2 items-center">
                            <p className="mb-0 text-ep-primary-600 text-sm">Show on the payslip?</p>
                            <div>
                                <CustomSwitch disabled={isViewing} active={form?.is_shown_on_payslip || false} activeText="Yes"
                                inactiveText="No" onChange={() => setForm({...form, is_shown_on_payslip: !form.is_shown_on_payslip})} />
                            </div>
                        </div>

                        <div className="border p-2">
                                <div className="flex-btw items-center">
                                    <p className="mb-0 text-ep-primary-600 text-sm">Is this taxable?</p>
                                    <div>
                                        <CustomSwitch disabled={isViewing} active={form?.is_taxable || false} activeText="Yes"
                                        inactiveText="No" onChange={() => setForm({...form, is_taxable: !form.is_taxable})} />
                                    </div>
                                </div>
                                
                                <Maybe condition={form?.is_taxable && isViewing === false}>
                                    <div className="flex items-center w-full mt-3">
                                        {/* <div className='flex items-center mr-10'>
                                                <input type="radio" checked={companyTaxed} onChange={toggleRadios} className="w-3 h-3 form-radio rounded-full mr-3" />
                                                <p style={{fontSize: 10}} className='mb-0'>Company</p>
                                        </div> */}
                                        <div className='flex items-center'>
                                                <input type="radio" onChange={() => null} checked={form?.is_taxable || false} className="w-3 h-3 form-radio rounded-full mr-3" />
                                                <p style={{fontSize: 10}} className='mb-0'>Employee</p>
                                        </div>
                                    </div>
                                </Maybe>
                            </div>
                    </div>
                    <button type="submit" ref={submitRef} style={{display: 'none'}} className="btn btn-md btn-ep-primary">Save Edits</button>
                </form>
        )
}

export default EditAllowanceForm